export const ClaimsStyles = {
  claimsContainer: {
    padding: "0px 30px",
    display: "grid",
    gap: "20px",
    borderRadius: "10px",
    border: "1px",
    "@media only screen and (max-width: 768px)": {
      padding: "0px 20px",
    },
  },
  claimCardsContainerHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  heading: {
    color: "#383D4E",
    fontSize: "20px",
    fontWeight: 400,
    fontFamily: "Playfair Display",
  },
  viewAll: {
    display: "flex",
    alignItems: "center",
    gap: "5px",
    cursor: "pointer",
  },
  viweAllText: {
    fontFamily: "Noto Sans",
    fontSize: "18px",
    fontWeight: "400",
    color: "#000000",
    "@media (max-width:599px)": {
      fontSize: "14px",
    },
  },
  claims: {
    display: "grid",
    gap: "20px",
  },
  noClaimsCard: {
    padding: "30px",
    border: "1px solid #C9E1EC",
    boxShadow: "0px 0px 10px 0px rgba(0, 0, 0, 0.1)",
  },
  noClaimsText: {
    overflow: "hidden",
    color: "#1D252B",
    fontSize: "18px",
    fontFamily: "Noto Sans",
    fontWeight: "400",
    textOverflow: "ellipsis",
    "@media (max-width:599px)": {
      fontSize: "16px",
    },
    "@media (min-width:600px) and (max-width:1366px)": {
      whiteSpace: "nowrap",
    },
  },
  link: {
    display: "flex",
    alignItems: "center",
    color: "#1D252B",
    fontFamily: "Noto Sans",
    fontSize: "18px",
    fontWeight: 400,
    cursor: "pointer",
    "@media (max-width: 599px)": {
      fontSize: "14px",
    },
    "@media (min-width: 600px) and (max-width: 1024px)": {
      fontSize: "16px",
    },
    "@media (min-width: 1024px) and (max-width: 1920px)": {
      fontSize: "18px",
    },
  },
  allClaimsListContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "20px",
    minHeight: "92vh",
    paddingX: "30px",
  },
};
